import { createContext, useContext } from 'react'
import FaxUsageStore from './faxUsage'
import UserStore from './user'
import TeamStore from './team'
import AppStore from './app'
import GroupsStore from './groups'
class RootStore {
  public readonly faxUsageStore: FaxUsageStore
  public readonly userStore: UserStore
  public readonly teamStore: TeamStore
  public readonly appStore: AppStore
  public readonly groupStore: GroupsStore

  constructor() {
    this.faxUsageStore = new FaxUsageStore()
    this.userStore = new UserStore()
    this.teamStore = new TeamStore(this)
    this.appStore = new AppStore()
    this.groupStore = new GroupsStore()
  }
}

const store = new RootStore()

export const StoreContext = createContext(store)
export const useStores = () => useContext(StoreContext)

export const getRootStore = () => store

export const useTeamStore = () => useStores().teamStore
export const useUserStore = () => useStores().userStore
export const useGroupsStore = () => useStores().groupStore
export const useAppStore = () => useStores().appStore
export const useFaxUsageStore = () => useStores().faxUsageStore

export default store
